'use client'

import {useSidebar} from '@app/components/sidebar/sidebar-visiblity-context'
import clsx from 'clsx'
import s from './style.module.scss'
import {useIsGamePage} from '../content-wrapper/content-wrapper-client'

type Props = {
  children: React.ReactNode
}

const SidebarControlledWidthWrapperClient = ({children}: Props) => {
  const {isOpen} = useSidebar()
  const {isGamePage} = useIsGamePage()

  return (
    <div
      className={clsx({
        [s.sidebar_open]: isOpen,
        [s.sidebar_closed]: !isOpen || isGamePage,
      })}
    >
      {children}
    </div>
  )
}

export default SidebarControlledWidthWrapperClient
